import ListPaymentMethods from './payment-methods/list-of-payment-methods.component';
import PriceDetails from './prices/price-details.component';
import Header from './header.component';

export const PurchasePaymentMethods = () => {
  return (
    <div className="co-w-full co-flex co-flex-col co-rounded-8px co-gap-16px co-py-24px co-px-16px co-border-1 co-border-[#E6E6E6] co-bg-white lg:co-py-24px lg:co-px-32px">
      <Header />
      <div className="co-flex co-flex-col co-gap-24px lg:co-flex-row">
        <ListPaymentMethods />
        <PriceDetails />
      </div>
    </div>
  );
};
